import React, { useState } from "react";
import "../css/user.css";
import arrow from '../img/arrow.png';
import '../css/popup.css';
import Modal from '../components/popupModalMines';

function Output({ name, date, download, textAction, action, deleteFile , renameFile}) {
    const [isManageMineVisible, setIsManageMineVisible] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
    const [newName, setNewName] = useState("");

    const toggleManageMine = () => {
        setIsManageMineVisible(!isManageMineVisible);
    };

    const openDeleteModal = () => {
        setIsDeleteModalOpen(true);
    };

    const openRenameModal = () => {
        setIsRenameModalOpen(true);
    };

    const confirmDelete = () => {
        deleteFile();
        console.log("File deleted permanently");
        setIsDeleteModalOpen(false);
    };

    const confirmRename = () => {
        renameFile(newName);
        console.log("File renamed to:", newName);
        setIsRenameModalOpen(false);
    };

    return (
        <>
            <div className="output">
                <p className="textlink OutputField"><b>Name:</b> {name}</p>
                {date && <p className="textlink smallOutputField"><b>Date:</b> {date}</p>}
                <div>
                    <button type="submit" className="button buttonUser" onClick={action}>
                        {textAction}
                    </button>
                    {download && (
                        <>
                            &nbsp;&nbsp;
                            <button type="submit" className="button buttonUser download-button" onClick={download}>
                                Download
                            </button>
                        </>
                    )}
                </div>
                <img
                    src={arrow}
                    alt="Manage Mine Area"
                    className={`arrowbutton ${isManageMineVisible ? 'rotated' : ''}`}
                    onClick={toggleManageMine}
                />
            </div>

            <div className={`ManageMine ${isManageMineVisible ? 'visible' : ''}`} id={name}>
                <div className="ManageMineButtonArea">
                    <button
                        type="button"
                        className="button buttonUser"
                        onClick={openRenameModal}
                    >
                        Rename
                    </button>
                    &nbsp;
                    <button
                        type="button"
                        className="button buttonUser dangerbutton"
                        onClick={openDeleteModal}
                    >
                        Delete
                    </button>
                </div>
            </div>

            <div className="space"></div>

            {/* Delete Confirmation Modal */}
            {isDeleteModalOpen && (
                <Modal
                    isOpen={isDeleteModalOpen}
                    title="Confirm Deletion"
                    message="Are you sure you want to permanently delete this file from storage?"
                    onClose={() => setIsDeleteModalOpen(false)}
                >
                    <div className="button-group">
                        <button
                            type="button"
                            className="sign-button button"
                            onClick={() => setIsDeleteModalOpen(false)}
                        >
                            Keep File
                        </button>
                        <button
                            type="button"
                            className="sign-button button dangerbutton"
                            onClick={() => confirmDelete()}
                        >
                            Delete File
                        </button>
                    </div>
                </Modal>
            )}

            {/* Rename File Modal */}
            {isRenameModalOpen && (
                <Modal
                    isOpen={isRenameModalOpen}
                    title="Rename File"
                    message="Please enter the new name for the file:"
                    onClose={() => setIsRenameModalOpen(false)}
                >
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        confirmRename();
                    }}>
                        <input
                            type="text"
                            id="filename"
                            name="filename"
                            value={newName}
                            onChange={e => setNewName(e.target.value)}
                            placeholder="Enter only letters and numbers..."
                            pattern="[A-Za-z0-9]{5,}"
                            title="Only letters and numbers (no space or special characters), at least 5 characters."
                            minLength={5}
                            required
                        />
                        <button type="submit" className="sign-button button">Rename file</button>
                        <button
                            type="button"
                            className="sign-button button dangerbutton"
                            onClick={() => setIsRenameModalOpen(false)}
                        >
                            Keep filename
                        </button>
                    </form>
                </Modal>
            )}
        </>
    );
}

export default Output;
